import { render, staticRenderFns } from "./DropArea.vue?vue&type=template&id=0edb1358&"
import script from "./DropArea.vue?vue&type=script&lang=js&"
export * from "./DropArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports